import { useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { useTranslations } from 'next-intl';
import { Image } from '@/component/Image';
import { Navigation, Pagination, EffectFade } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import styles from './styles.module.css';

export const MyCarousel = ({
  images,
  width,
  height,
  pagination = true,
  onClick,
  classWrap,
  dataTestId,
  url,
}) => {
  const t = useTranslations();
  const [isImageReady, setIsImageReady] = useState(false);

  const onLoadCallBack = (e) => {
    setIsImageReady(true);
    typeof onLoad === 'function' && onLoad(e);
  };
  return (
    <section
      className={`carousel-wrap ${styles.container} ${classWrap}`}
      data-testid={dataTestId}
    >
      <Swiper
        pagination={pagination}
        navigation
        effect={'fade'}
        modules={[Navigation, Pagination, EffectFade]}
        className={`swiper-carousel ${styles.carousel}`}
      >
        {images.map((image) => {
          const img = (
            <Image
              className={`opacity-0 transition-opacity duration-300 ${
                isImageReady ? 'opacity-100' : ''
              }`}
              height={height || 270}
              width={width || 300}
              alt={image.altText || ''}
              title={image.caption || t('apartment.gallery.photo')}
              src={image.url}
              onLoad={onLoadCallBack}
            />
          );

          return (
            <SwiperSlide key={image.url} onClick={onClick}>
              <a {...url} rel="noopener norefeerrer nofollow">
                {img}
              </a>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </section>
  );
};
